<app-icon [icon]="fileIcon().icon" [width]="size()" [height]="size()" [alt]="fileIcon().alt" />
